/* ------------------------------------------------------------------
   Lumière Noir — capa de movimiento
   Sin librerias. Todo con IntersectionObserver y requestAnimationFrame.

   Regla de oro: la clase .ln-js la pone este script. Si el script no
   carga, el CSS que esconde cosas nunca se aplica y la pagina se ve
   entera. Nunca dejamos contenido invisible esperando a nada.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var raiz = document.documentElement;
  var suave = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  raiz.classList.add('ln-js');
  if (suave) raiz.classList.add('ln-suave');   // el CSS deja solo fundidos

  /* ---------- 1. Aparicion al entrar en pantalla ---------- */

  var SELECTORES = [
    '.ln-sec-head', '.ln-step', '.ln-active', '.ln-test', '.ln-guar',
    '.ln-thesis .copy', '.ln-thesis figure', '.ln-tablewrap', '.ln-faqlist',
    '.ln-strip-grid > div', '.ln-bullets li', '.ln-offer', '.ln-micro',
    '.lnh-head', '.lnh-card', '.lnh-strip-grid > div', '.lnh-hero .copy',
    '.lnc-head', '.lnc-card',
    '.lnv-intro', '.lnv-step', '.lnv-frame'
  ].join(',');

  var candidatos = document.querySelectorAll(SELECTORES);
  if (candidatos.length) {
    // Escalonado por grupos: los hermanos entran uno detras de otro.
    var porPadre = new Map();
    candidatos.forEach(function (el) {
      el.setAttribute('data-ln-reveal', '');
      var p = el.parentElement;
      var n = porPadre.get(p) || 0;
      el.style.setProperty('--ln-retardo', (Math.min(n, 5) * 70) + 'ms');
      porPadre.set(p, n + 1);
    });

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.setAttribute('data-ln-visto', '');
            obs.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

      candidatos.forEach(function (el) {
        // Lo que ya esta en pantalla al cargar se muestra sin esperar.
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.92) el.setAttribute('data-ln-visto', '');
        else obs.observe(el);
      });
    } else {
      candidatos.forEach(function (el) { el.setAttribute('data-ln-visto', ''); });
    }
  }

  /* ---------- 2. Cifras que cuentan al aparecer ---------- */

  function contar(el) {
    var bruto = (el.textContent || '').trim();
    var m = bruto.match(/^(\d+)(\s*[^\d]*)$/);      // "30", "24 h" si, "5–10" no
    if (!m) return;
    var fin = parseInt(m[1], 10);
    var cola = m[2] || '';
    if (!isFinite(fin) || fin === 0) return;
    if (suave) return;                                // sin numeros saltarines

    var ini = null, dur = 900;
    function paso(t) {
      if (ini === null) ini = t;
      var p = Math.min(1, (t - ini) / dur);
      var suavizado = 1 - Math.pow(1 - p, 3);         // ease-out cubic
      el.textContent = Math.round(fin * suavizado) + cola;
      if (p < 1) requestAnimationFrame(paso);
      else el.textContent = fin + cola;
    }
    el.textContent = '0' + cola;
    requestAnimationFrame(paso);
  }

  var cifras = document.querySelectorAll('.ln-strip .k, .lnh-strip .k');
  if (cifras.length && 'IntersectionObserver' in window) {
    var obsNum = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { contar(e.target); obsNum.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    cifras.forEach(function (el) { obsNum.observe(el); });
  }

  /* ---------- 3. Parallax de la foto de portada ---------- */

  var fondo = document.querySelector('.lnh-bg img');
  if (fondo && !suave) {
    var pendiente = false;
    function mover() {
      pendiente = false;
      var y = window.scrollY;
      if (y > window.innerHeight * 1.2) return;       // fuera de vista, no gastamos
      fondo.style.transform = 'scale(1.10) translate3d(0,' + (-y * 0.16) + 'px,0)';
    }
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; requestAnimationFrame(mover); }
    }, { passive: true });
    mover();
  }

  /* ---------- 4. Barra de progreso de lectura ---------- */

  if (!document.getElementById('ln-progreso')) {
    var barra = document.createElement('div');
    barra.id = 'ln-progreso';
    barra.innerHTML = '<span></span>';
    document.body.appendChild(barra);
    var relleno = barra.firstChild, pend2 = false;
    function progreso() {
      pend2 = false;
      var alto = document.documentElement.scrollHeight - window.innerHeight;
      var p = alto > 0 ? (window.scrollY / alto) : 0;
      relleno.style.transform = 'scaleX(' + Math.min(1, Math.max(0, p)) + ')';
    }
    window.addEventListener('scroll', function () {
      if (!pend2) { pend2 = true; requestAnimationFrame(progreso); }
    }, { passive: true });
    progreso();
  }

  /* ---------- 5. Buscador: solo los productos del catalogo real ----------
     Los demas siguen existiendo en la tienda (los packs los necesitan para
     anadirse al carrito), pero no se ofrecen al cliente. Si algun dia quieres
     vender otro, anade su handle aqui. */

  var PERMITIDOS = [
    'silicone-ice-facial-massage-tray'
  ];

  function permitido(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    if (!m) return true;                       // no es un producto: se queda
    return PERMITIDOS.indexOf(m[1]) !== -1;
  }

  function limpiar(raizBusqueda) {
    raizBusqueda.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (permitido(a.getAttribute('href'))) return;
      // subimos hasta la tarjeta/elemento de lista que envuelve el enlace
      var item = a.closest('li, [class*="card"], [class*="result"], [class*="item"]');
      (item || a).remove();
    });
    // si una lista se queda vacia, fuera ella y su titulo
    raizBusqueda.querySelectorAll('ul, ol').forEach(function (lista) {
      if (!lista.children.length) {
        var prev = lista.previousElementSibling;
        if (prev && /^(H\d|P|SPAN|DIV)$/.test(prev.tagName) && prev.textContent.trim().length < 30) prev.remove();
        lista.remove();
      }
    });
  }

  var CONTENEDORES = '[class*="predictive"], [class*="search-result"], [class*="search__results"], #predictive-search, .template-search, [id*="search-results"]';

  function vigilarBusqueda() {
    document.querySelectorAll(CONTENEDORES).forEach(function (c) {
      if (c.hasAttribute('data-ln-filtrado')) return;
      c.setAttribute('data-ln-filtrado', '');
      limpiar(c);
      new MutationObserver(function () { limpiar(c); })
        .observe(c, { childList: true, subtree: true });
    });
  }

  vigilarBusqueda();
  // el buscador suele montarse al abrirlo, no al cargar la pagina
  new MutationObserver(vigilarBusqueda).observe(document.body, { childList: true, subtree: true });

  /* ---------- 6. Brillo que sigue al cursor en la caja de compra ---------- */

  if (!suave && window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('.ln-tier, .lnh-card, .lnc-card').forEach(function (el) {
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--ln-x', ((ev.clientX - r.left) / r.width * 100) + '%');
        el.style.setProperty('--ln-y', ((ev.clientY - r.top) / r.height * 100) + '%');
      });
    });
  }
})();
